import { useState, useEffect } from "react";

// Encapsulates in-progress fence drawing: draft points, live cursor segment,
// finish (double-click) and cancel (Esc). s2w maps screen->world coords.
export function useFenceDraw({ drawingFence, s2w, onFenceCommit }) {
  const [fenceDraft, setFenceDraft] = useState([]);
  const [fenceCursor, setFenceCursor] = useState(null);

  const addPoint = (clientX, clientY) => setFenceDraft((d) => [...d, s2w(clientX, clientY)]);

  const trackCursor = (clientX, clientY) => {
    setFenceDraft((d) => {
      if (d.length > 0) setFenceCursor(s2w(clientX, clientY));
      return d;
    });
  };

  const cancel = () => { setFenceDraft([]); setFenceCursor(null); };

  const finishFence = () => {
    // dedupe trailing duplicate points produced by the finishing double-click
    const pts = [];
    for (const p of fenceDraft) {
      const last = pts[pts.length - 1];
      if (!last || Math.hypot(p.x - last.x, p.y - last.y) > 2) pts.push(p);
    }
    if (pts.length >= 2 && onFenceCommit) onFenceCommit(pts);
    cancel();
  };

  // Escape cancels an in-progress fence
  useEffect(() => {
    if (!drawingFence) return;
    const onKey = (e) => { if (e.key === "Escape") cancel(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [drawingFence]);

  return { fenceDraft, fenceCursor, addPoint, trackCursor, finishFence, cancel };
}
